export default __webpack_public_path__ + "static/media/sgtf-box.4f38fda6.png";